export default {
  methods: {
    formatNumberWithSign(value, prefix = '', suffix = '') {
      const parts = value.toString().split('.');
      const integerPart = parts[0];
      const decimalPart = parts[1] ? '.' + parts[1] : '';
      const sign = value >= 0 ? '+' : '';

      const formattedInteger = integerPart
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3})(?=\d)/g, '$1 ')
        .split('')
        .reverse()
        .join('');

      return sign + prefix + formattedInteger + decimalPart + suffix;
    },
  },
};

export const NumberFormatter = () => {
  const formatNumber = (value, {
    prefix = '',
    suffix = '',
    separator = ' ',
    showSign = false,
    hideDecimalIfZero = false,
    precision = null
  } = {}) => {
    if (value === null || value === undefined) {
      return '';
    }

    const numValue = Number(value);
    const sign = showSign && numValue >= 0 ? '+' : '';

    let formattedValue;
    if (precision !== null && precision !== undefined) {
      formattedValue = numValue.toFixed(Math.max(0, Math.floor(precision)));
    } else {
      formattedValue = value.toString();
    }

    const parts = formattedValue.split('.');
    const integerPart = parts[0];
    let decimalPart = parts[1] ? '.' + parts[1] : '';

    if (hideDecimalIfZero && decimalPart) {
      const decimalDigits = decimalPart.slice(1);
      if (/^0+$/.test(decimalDigits)) {
        decimalPart = '';
      }
    }

    const formattedInteger = integerPart
      .split('')
      .reverse()
      .join('')
      .replace(/(\d{3})(?=\d)/g, `$1${separator}`)
      .split('')
      .reverse('')
      .join('');

    return sign + prefix + formattedInteger + decimalPart + suffix;
  };

  const formatNumberCompact = (value, prefix = '', suffix = '', precision = 1) => {
    if (typeof value !== 'number' || isNaN(value)) {
      return '';
    }

    const absValue = Math.abs(value);
    let formattedValue;
    let numberSuffix = '';

    if (absValue >= 1000000) {
      formattedValue = (absValue / 1000000).toFixed(precision);
      numberSuffix = 'm';
    } else if (absValue >= 1000) {
      formattedValue = (absValue / 1000).toFixed(precision);
      numberSuffix = 'k';
    } else {
      formattedValue = absValue.toString();
      if (precision === 0 && formattedValue.endsWith('.0')) {
        formattedValue = formattedValue.substring(0, formattedValue.length - 2);
      }

      if (!numberSuffix) {
        formattedValue = absValue.toFixed(precision);
        if (precision === 0) {
          formattedValue = Math.round(absValue).toString();
        }
      }
    }

    if (precision === 1 && formattedValue.endsWith('.0') && (numberSuffix === 'k' || numberSuffix === 'm')) {
      formattedValue = formattedValue.slice(0, -2);
    }

    return prefix + formattedValue + numberSuffix + suffix;
  };

  return {
    formatNumber,
    formatNumberCompact,
  };
};
